// extracted by mini-css-extract-plugin
export var procesosContainer = "ProcesoEducativo-module--procesosContainer--Wgq8o";